import React from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { updateFavorites } from '../../actions/AppActions';
import { isFavorite, removeFromSimple } from './favoriteUtils';

const stackStyle = {
  alignItems: 'center',
  cursor: 'pointer',
  display: 'flex',
  fontSize: '22px',
  height: '24px',
  justifyContent: 'center',
  lineHeight: '24px',
  textAlign: 'center',
  width: '21.78px',
};

const FavoriteIcon = ({ pageName }) => {
  const dispatch = useDispatch();
  const { favoriteList } = useSelector(state => state.app.userData);

  const toggleFavorite = () => {
    if (isFavorite(favoriteList.list, pageName)) {
      return dispatch(updateFavorites(favoriteList.id, { list: removeFromSimple(favoriteList.list, pageName) }));
    }

    return dispatch(updateFavorites(favoriteList.id, { list: [...favoriteList.list, pageName] }));
  };

  const starColor = isFavorite(favoriteList.list, pageName) ? '#FFEB3B' : '#FFFFFF';

  return (
    <span className="fa-stack" style={stackStyle} onClick={toggleFavorite}>
      <i className="fa-regular fa-star-sharp fa-stack-1x" style={{ fontSize: '22px' }} />
      <i className="fa-solid fa-star-sharp" style={{ color: starColor, fontSize: '18px' }} />
    </span>
  );
};

FavoriteIcon.propTypes = {
  pageName: PropTypes.string,
};

export default FavoriteIcon;
